import PropTypes from 'prop-types';
import React from 'react';
import { JournalText } from 'react-bootstrap-icons';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ProductDetailAttributeCard from './ProductDetailAttributeCard';

function ProductAttributesSection({ attributes = [], theme, t }) {
	const hasAttributes = attributes.length > 0;

	return (
		<>
			<Grid
				item
				xs={12}
				aria-label={t('specs')}
				style={{ marginTop: theme.spacing(4) }}
			>
				<Grid container>
					<Grid item xs={12} aria-label={t('specs')}>
						<JournalText
							style={{
								fontSize: '1.35rem',
								marginBottom: '-.27rem',
								marginRight: '.44rem',
							}}
							aria-label="Journal Text"
							role="graphics-symbol"
							aria-hidden="true"
						/>
						<Typography
							variant="heading7"
							aria-label={t('specs')}
							role="paragraph"
						>
							{t('specs')}
						</Typography>
						<Divider
							sx={{ my: 1 }}
							aria-label={t('specs')}
							tabIndex={-1}
							role="presentation"
						/>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Grid container>
					{hasAttributes ? (
						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={12}>
									<Grid container spacing={2}>
										{attributes.map((detail) => (
											<Grid
												item
												lg={3}
												sm={4}
												xs={12}
												key={`${detail.Name}-${detail.Value}`}
											>
												<ProductDetailAttributeCard
													name={t(
														`specs_details.${detail.Name}`,
														`${detail.Name}`
													)}
													value={detail.Value}
												/>
											</Grid>
										))}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					) : (
						<Grid item xs={12}>
							<Typography variant="caption" color="textSecondary">
								{t('no_specifications')}
							</Typography>
						</Grid>
					)}
				</Grid>
			</Grid>
		</>
	);
}

ProductAttributesSection.propTypes = {
	attributes: PropTypes.arrayOf(PropTypes.object),
	t: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
};

export default ProductAttributesSection;
